import {array, partial, string, TypeOf} from 'io-ts';
import {ErroneousServerResult, expectOneOf, HttpClient, POST, ServerValidationResult} from '~/library/network-facade';

export interface ChangePasswordInterface {
    old_password: string;
    new_password: {
        first: string;
        second: string;
    };
}

export const ChangePasswordValidationResult = ServerValidationResult.createCodec(
    partial({
        old_password: array(string),
        new_password: partial({
            first: array(string),
            second: array(string),
        }),
    })
);
export type ChangePasswordValidationResult = TypeOf<typeof ChangePasswordValidationResult>;

export const changePassword = (http: HttpClient, data: ChangePasswordInterface) =>
    http('v1/change_password', POST(data)).then(
        expectOneOf({
            200: null,
            400: ChangePasswordValidationResult,
            401: null,
            422: ErroneousServerResult,
        })
    );
